<template>
  <div class="calico-dropdown">
    <div
      class="field"
      :class="{
        error,
        disabled,
        'has-value': !!modelValue
      }"
    >
      <template v-if="showBadge">
        <div class="badge-container">
          <span :class="badgeColor">{{ badgeLabel }}</span>
        </div>
      </template>

      <select
        :value="modelValue"
        v-bind="filteredAttrs"
        :disabled="disabled"
        class="native-select body--medium"
        @change="handleChange"
        @blur="$emit('blur')"
      >
        <option
          value=""
          disabled
          hidden
        >
          {{ placeholder }}
        </option>
        <slot />
      </select>

      <i class="bi bi-caret-down-fill" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoDropdown",
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    showBadge: {
      type: Boolean,
      default: false,
    },
    badgeColor: {
      type: String,
      default: "green",
    },
    badgeLabel: {
      type: String,
      default: "Badge",
    },
    placeholder: {
      type: String,
      default: "Select",
    },
  },
  emits: ['update:modelValue'],
  computed: {
    filteredAttrs() {
      const attrs = { ...this.$attrs };
      delete attrs.value;
      delete attrs.modelValue;
      delete attrs.onChange;
      delete attrs.onInput;
      return attrs;
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('update:modelValue', event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.calico-dropdown {
  position: relative;
  width: 100%;

  .field {
    @include inline-space($space-none);
    align-items: center;
    justify-content: space-between;
    @include inset-space($space-small);
    color: $color-neutral-dark;
    border: $border-width-default solid $color-neutral-light;
    border-radius: $radius-small;
    background: $color-white;
    padding: 12px $space-medium;

    &:focus-within {
      outline: none;
      border-color: $color-border-primary;
    }

    &.has-value {
      border: $border-width-default solid $color-black;
      color: $color-black;
    }

    &.disabled {
      color: $color-text-secondary;
      background: $color-neutral-lightest;
      border: $border-width-default solid $color-neutral-lightest;
      cursor: not-allowed;
    }

    &.error {
      border: $border-width-default solid $color-border-error;
      background: $color-background-error;
      color: $color-red-dark;
    }

    .bi-caret-down-fill {
      font-size: $icon-xsmall;
      color: $color-black;
      pointer-events: none;
    }

    .badge-container {
      @include inline-space($space-none);
      align-items: center;
      justify-content: flex-start;
      gap: $space-xsmall;
      cursor: pointer;

      .calico-badge {
        width: auto;

        :deep(.badge) {
          border-radius: var(--radius-round, 100px);
        }
      }
    }

    .native-select {
      flex: 1;
      border: none;
      background: transparent;
      color: inherit;
      cursor: pointer;
      outline: none;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;

      &::-ms-expand {
        display: none;
      }

      &:disabled {
        cursor: not-allowed;
      }
    }
  }
}
</style>
